import { useTranslation } from 'react-i18next';

import { isRequestIcon } from 'app/lib/is-request-icon';
import { RequestImage } from 'app/components/request-image';
import { Pressable } from 'react-native';
import { Column, Row } from 'app/design/primitives/box';
import { PCImage } from 'app/design/primitives/image';
import { Text } from 'app/design/primitives/text';
import { createTheme as createDSTheme } from 'app/shopify';
const theme = createDSTheme();

export const GroupedChannels = function GroupedChannels({
  listingName,
  userName,
  count,
  picture,
  isUserGroup,
  onPress,
  numUnread,
}: {
  listingName?: string;
  userName?: string;
  count: number;
  picture: string;
  isUserGroup?: boolean;
  numUnread: number;
  onPress: () => void;
}) {
  const { t } = useTranslation('all-channels');
  return (
    <Pressable onPress={onPress}>
      <Row alignItems="center" gap="spacing.general.x3">
        {!isUserGroup && isRequestIcon(picture) ? (
          <Column borderRadius="radius.full" height={60} overflow="hidden" width={60}>
            <RequestImage width={60} height={60} />
          </Column>
        ) : (
          <Column
            borderRadius="radius.full"
            overflow="hidden"
            style={{
              boxShadow: `0px 2px 1px ${theme.colors['text.primary']}99`,
            }}
          >
            <PCImage aspectRatio={1} height={60} source={{ uri: picture }} />
          </Column>
        )}
        <Column flex={1} justifyContent="center">
          <Row alignItems="center">
            <Text fontWeight="700" numberOfLines={1} variant="bodyBase" flex={1} style={{ flexShrink: 1 }}>
              {listingName ?? userName ?? ''}
            </Text>
            {numUnread > 0 ? (
              <Column
                alignItems="center"
                backgroundColor="icon.error"
                borderRadius="radius.full"
                height={8}
                justifyContent="center"
                width={8}
              />
            ) : null}
          </Row>

          <Text color="text.secondary" variant="bodyBase">
            {t('groupConversationCount', { count })}
          </Text>
        </Column>
      </Row>
    </Pressable>
  );
};
